
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import * as signalR from '@microsoft/signalr';
//import style from '../../Tools/Style';
import {
  Toolbar,
  IconButton,
  Button,
  Avatar,
  Drawer,
  Badge,
  Tooltip,
  Box,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useStateValue } from '../../../contexto/store';
import { MenuIzquierda } from './menuIzquierda';
import { withRouter } from 'react-router-dom';
import { MenuDerecha } from './menuDerecha';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import Email from '@mui/icons-material/Email';
import NearMeIcon from '@mui/icons-material/NearMe';
import { RecordVoiceOver } from '@mui/icons-material';
import { obtenerTareasNotificacion } from '../../../actions/TareasAction';
import {
  contarDifusionesDelDia,
  obtenerNotasNoLeidas,
} from '../../../actions/NotasAction';
import {
  obtenerCobranzasNotificacion,
  obtenerPosiblesCobrosNotificacion,
  obtenerFacturasBajaNotificacion,
} from '../../../actions/CobranzasAction';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
const useStyles = makeStyles((theme) => ({
  seccionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  seccionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  grow: {
    flexGrow: 1,
  },
  avatarSize: {
    width: 40,
    height: 40,
    border: '2px solid rgba(255,255,255,0.3)',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'scale(1.1)',
      borderColor: 'rgba(255,255,255,0.8)',
    },
  },
  list: {
    width: 280,
    backgroundColor: '#fafafa',
  },
  listItemText: {
    fontSize: '14px',
    fontWeight: 600,
    paddingLeft: '15px',
    color: '#212121',
  },
  contenedorIconos: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  iconButton: {
    color: 'inherit',
    transition: 'all 0.2s ease',
    '&:hover': {
      transform: 'scale(1.1)',
      backgroundColor: 'rgba(255,255,255,0.1)',
    },
  },
  badge: {
    '& .MuiBadge-badge': {
      fontWeight: 600,
      fontSize: '0.7rem',
      minWidth: '20px',
      height: '20px',
      padding: '0 5px',
    },
  },
  menuButton: {
    marginRight: theme.spacing(1),
    transition: 'all 0.2s ease',
    '&:hover': {
      transform: 'rotate(90deg)',
    },
  },
  brandButton: {
    fontSize: '1.1rem',
    fontWeight: 700,
    letterSpacing: '0.5px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.1)',
    },
  },
  logoutButton: {
    marginRight: theme.spacing(1),
    borderRadius: '8px',
    fontWeight: 600,
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.15)',
    },
  },
  userButton: {
    marginRight: theme.spacing(1),
    borderRadius: '8px',
    fontWeight: 500,
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.1)',
    },
  },
}));

const BarSesion = (props) => {
  const classes = useStyles();
  const mounted = useRef(true);
  const [{ sesionUsuario }, dispatch] = useStateValue();
  const [abrirMenuIzquierda, setAbrirMenuIzquierda] = useState(false);
  const [abrirMenuDerecha, setAbrirMenuDerecha] = useState(false);
  const [tareasDelDia, setTareasDelDia] = useState(0);
  const [posiblesCobros, setPosiblesCobros] = useState(0);
  const [notasNoLeidas, setNotasNoLeidas] = useState(0);
  const [difusionesDelDia, setDifusionesDelDia] = useState(0);
  const [cobranzasAsignadas, setCobranzasAsignadas] = useState(0);
  const [facturasPendientesDeBaja, setFacturasPendientesDeBaja] = useState(0);

  const [notificaciones, setNotificaciones] = useState(false);
  const [cobrosNoti, setCobrosNoti] = useState(false);
  const [notasrecibidas, setNotasRecibidas] = useState(false);
  const [posiblesCobrosNoti, setPosibleCobrosNoti] = useState(false);
  const [facturasBajaNoti, setFacturasBajaNoti] = useState(false);
  const [difusionesNoti, setDifusionesNoti] = useState(false);
  const [tareasNoti, setTareasNoti] = useState(false);

  const evaluarPermiso = (arrayrevisar, ruta) => {
    var boolEvaluacion = false;

    let existe = arrayrevisar.filter((pantallazo) => pantallazo.path === ruta);

    if (existe.length > 0) {
      boolEvaluacion = true;
    }

    return boolEvaluacion;
  };

  const cerrarMenuIzquierda = () => {
    setAbrirMenuIzquierda(false);
  };
  const abrirMenuIzquierdaAction = () => {
    setAbrirMenuIzquierda(true);
  };
  const cerrarMenuDerecha = () => {
    setAbrirMenuDerecha(false);
  };
  const abrirMenuDerechaAction = () => {
    setAbrirMenuDerecha(true);
  };

  const salirSesionApp = () => {
    localStorage.removeItem('token_seguridad');
    dispatch({
      type: 'SALIR_SESION',
      nuevoUsuario: null,
      autenticado: false,
    });
    props.history.push('/login');
  };

  useEffect(() => {
    if (mounted.current) {
      /*RRR: seccion SignalR para notificaciones a tiempo real*/
      const hubConnection = new signalR.HubConnectionBuilder()
        .withUrl(
          'http://localhost:19405/chatHub?username=' +
            sesionUsuario.usuario.userName
        )
        .build();
      hubConnection
        .start()
        .catch((err) => console.error('SignalR Connection Error: ', err));

      hubConnection.on('CuentaTareas', (TAREAS) => {
        setTareasDelDia(TAREAS.cuenta);
      });
      hubConnection.on('CuentaNotasNoLeidas', (NOTASNOLEIDAS) => {
        setNotasNoLeidas(NOTASNOLEIDAS.cuenta);
      });
      hubConnection.on('CuentaDifusionesDelDia', (DIFUSIONESDELDIA) => {
        setDifusionesDelDia(DIFUSIONESDELDIA.cuenta);
      });
      hubConnection.on('CuentaPosiblesCobros', (POSIBLESCOBROS) => {
        setPosiblesCobros(POSIBLESCOBROS.cuenta);
      });
      hubConnection.on('CuentaFacturasPendientesDeBaja', (FACTURAS) => {
        setFacturasPendientesDeBaja(FACTURAS.cuenta);
      });

      let objetoNoti = {
        USUARIOASIGNADO: sesionUsuario.usuario.nombrecompleto,
        UserName: sesionUsuario.usuario.userName,
      };
      // /*RRR: en esta seccion se traen las notificaciones por primera vez 
      // que se inicia el sistema y/o al actualizar el sistema */
      // obtenerTareasNotificacion(objetoNoti).then((response1) => {
      //   if (response1 === undefined) {
      //     obtenerTareasNotificacion(objetoNoti).then((response2) => {
      //       //console.log("??", response2)
      //       if(response2){
      //       setTareasDelDia(response2.data.cuenta);
      //       }
      //     });
      //   } else {
      //     setTareasDelDia(response1.data.cuenta);
      //   }
      // });
    // zinri se manejan errores
        obtenerTareasNotificacion(objetoNoti)
          .then((response) => {
            if (response && response.data) {
              setTareasDelDia(response.data.cuenta);
            }
          })
          .catch((error) => {
            console.error("Error al obtener tareas:", error);
            setTareasDelDia(0);
          });


      let objetoNotiNota = {
        USUARIOASIGNADO: sesionUsuario.usuario.userName,
        UserName: sesionUsuario.usuario.userName,
      };
      // obtenerNotasNoLeidas(objetoNotiNota).then((response) => {
      //   if (response === undefined) {
      //     obtenerNotasNoLeidas(objetoNoti).then((response) => {
      //       setNotasNoLeidas(response.data.cuenta);
      //     });
      //   } else {
      //     setNotasNoLeidas(response.data.cuenta);
      //   }
      // });
      //zinri manejo errores
      obtenerNotasNoLeidas(objetoNoti)
      .then((res) => {
        if (res && res.data) setNotasNoLeidas(res.data.cuenta);
        else setNotasNoLeidas(0);
      })
      .catch((err) => {
        console.error("Error al obtener notas:", err);
        setNotasNoLeidas(0);
      });
      //     contarDifusionesDelDia().then((response) => {
      //   if (response === undefined) {
      //     contarDifusionesDelDia().then((response) => {
      //       setDifusionesDelDia(response.data.cuenta);
      //     });
      //   } else {
      //     setDifusionesDelDia(response.data.cuenta);
      //   }
      // });
      // zinri manejo errores
      contarDifusionesDelDia()
  .then((res) => {
    if (res && res.data) setDifusionesDelDia(res.data.cuenta);
    else setDifusionesDelDia(0);
  })
  .catch((err) => {
    console.error("Error al obtener difusiones:", err);
    setDifusionesDelDia(0);
  });

      // obtenerPosiblesCobrosNotificacion().then((response) => {
      //   if (response === undefined) {
      //     obtenerPosiblesCobrosNotificacion().then((response) => {
      //       setPosiblesCobros(response.data.cuenta);
      //     });
      //   } else {
      //     setPosiblesCobros(response.data.cuenta);
      //   }
      // });
      //zinri
      obtenerPosiblesCobrosNotificacion()
  .then((res) => {
    if (res && res.data) setPosiblesCobros(res.data.cuenta);
    else setPosiblesCobros(0);
  })
  .catch((err) => {
    console.error("Error al obtener posibles cobros:", err);
    setPosiblesCobros(0);
  });


      // obtenerCobranzasNotificacion(objetoNoti).then((response) => {
      //   if (response === undefined) {
      //     obtenerCobranzasNotificacion(objetoNoti).then((response) => {
      //       setCobranzasAsignadas(response.data.cuenta);
      //     });
      //   } else {
      //     setCobranzasAsignadas(response.data.cuenta);
      //   }
      // });
      obtenerCobranzasNotificacion(objetoNoti)
  .then((res) => {
    if (res && res.data) setCobranzasAsignadas(res.data.cuenta);
    else setCobranzasAsignadas(0);
  })
  .catch((err) => {
    console.error("Error al obtener cobranzas:", err);
    setCobranzasAsignadas(0);
  });

      // obtenerFacturasBajaNotificacion(objetoNoti).then((response) => {
      //   if (response === undefined) {
      //     obtenerFacturasBajaNotificacion(objetoNoti).then((response) => {
      //       setFacturasPendientesDeBaja(response.data.cuenta);
      //     });
      //   } else {
      //     setFacturasPendientesDeBaja(response.data.cuenta);
      //   }
      // });
      obtenerFacturasBajaNotificacion(objetoNoti)
  .then((res) => {
    if (res && res.data) setFacturasPendientesDeBaja(res.data.cuenta);
    else setFacturasPendientesDeBaja(0);
  })
  .catch((err) => {
    console.error("Error al obtener facturas pendientes de baja:", err);
    setFacturasPendientesDeBaja(0);
  });

      const VerificarPermisos = (arrPermisos) => {
        setNotificaciones(evaluarPermiso(arrPermisos, '/notificaciones'));
        setCobrosNoti(evaluarPermiso(arrPermisos, '/cobrosNoti'));
        setNotasRecibidas(evaluarPermiso(arrPermisos, '/notasrecibidas'));
        setPosibleCobrosNoti(
          evaluarPermiso(arrPermisos, '/posiblesCobrosNoti')
        );
        setDifusionesNoti(evaluarPermiso(arrPermisos, '/difusionesNoti'));
        setTareasNoti(evaluarPermiso(arrPermisos, '/tareasNoti'));
        setFacturasBajaNoti(evaluarPermiso(arrPermisos, '/facturasBajaNoti'));
      };

      if(sesionUsuario.usuario.pantallasUsuario){
        VerificarPermisos(
          sesionUsuario.usuario.pantallasUsuario.listaPantallasRol
        );
      }
      

    }

    return function cleanup() {
      mounted.current = false;
    };

  }, [sesionUsuario]);
  
  return (
    <React.Fragment>
      <Drawer
        open={abrirMenuIzquierda}
        onClose={cerrarMenuIzquierda}
        anchor="left"
        PaperProps={{
          sx: {
            width: 280,
            backgroundColor: '#fafafa',
            boxShadow: '2px 0 8px rgba(0,0,0,0.1)',
          },
        }}
      >
        <Box 
          className={classes.list} 
          onKeyDown={cerrarMenuIzquierda}
          sx={{ height: '100%' }}
        >
          <MenuIzquierda classes={classes} />
        </Box>
      </Drawer>

      <Drawer
        open={abrirMenuDerecha}
        onClose={cerrarMenuDerecha}
        anchor="right"
        PaperProps={{
          sx: {
            width: 280,
            backgroundColor: '#fafafa',
            boxShadow: '-2px 0 8px rgba(0,0,0,0.1)',
          },
        }}
      >
        <Box 
          className={classes.list} 
          onClick={cerrarMenuDerecha}
          sx={{ height: '100%' }}
        >
          <MenuDerecha
            classes={classes}
            salirSesion={salirSesionApp}
            usuario={sesionUsuario ? sesionUsuario.usuario : null}
          />
        </Box>
      </Drawer>

      <Toolbar sx={{ minHeight: { xs: 56, sm: 64 }, px: { xs: 2, sm: 3 } }}>
        <IconButton 
          color="inherit" 
          onClick={abrirMenuIzquierdaAction}
          className={classes.menuButton}
          sx={{ mr: 2 }}
        >
          <i className="material-icons">menu</i>
        </IconButton>

        <Button 
          color="inherit" 
          component={Link} 
          to="/"
          className={classes.brandButton}
        >
          Mandu@ CRM
        </Button>
        
        <div className={classes.grow}></div>

        <div className={classes.seccionDesktop}>
          {notificaciones && (
            <Box className={classes.contenedorIconos} sx={{ mr: 2 }}>
              {difusionesNoti && (
                <IconButton
                  component={Link}
                  to="/difusiones"
                  color="inherit"
                  className={classes.iconButton}
                >
                  <Tooltip title="Nuevas Difusiones" arrow>
                    <Badge
                      badgeContent={difusionesDelDia}
                      color="secondary"
                      className={classes.badge}
                    >
                      <RecordVoiceOver />
                    </Badge>
                  </Tooltip>
                </IconButton>
              )}

              {notasrecibidas && (
                <IconButton
                  component={Link}
                  to="/misNotas"
                  color="inherit"
                  className={classes.iconButton}
                >
                  <Tooltip title="Notas Nuevas" arrow>
                    <Badge
                      badgeContent={notasNoLeidas}
                      color="secondary"
                      className={classes.badge}
                    >
                      <Email />
                    </Badge>
                  </Tooltip>
                </IconButton>
              )}

              {tareasNoti && (
                <IconButton
                  component={Link}
                  to="/tareasPrincipal"
                  color="inherit"
                  className={classes.iconButton}
                >
                  <Tooltip title="Tareas" arrow>
                    <Badge
                      badgeContent={tareasDelDia}
                      color="secondary"
                      className={classes.badge}
                    >
                      <AssignmentLateIcon />
                    </Badge>
                  </Tooltip>
                </IconButton>
              )}

              {posiblesCobrosNoti && (
                <IconButton
                  component={Link}
                  to="/panelPosiblesCobrosPrincipal"
                  color="inherit"
                  className={classes.iconButton}
                >
                  <Tooltip title="Posibles Cobros" arrow>
                    <Badge
                      badgeContent={posiblesCobros}
                      color="secondary"
                      className={classes.badge}
                    >
                      <AttachMoneyIcon />
                    </Badge>
                  </Tooltip>
                </IconButton>
              )}

              {cobrosNoti && (
                <IconButton
                  component={Link}
                  to="/cobranzasAsignadas"
                  color="inherit"
                  className={classes.iconButton}
                >
                  <Tooltip title="Cobranzas Asignadas" arrow>
                    <Badge
                      badgeContent={cobranzasAsignadas}
                      color="secondary"
                      className={classes.badge}
                    >
                      <NearMeIcon />
                    </Badge>
                  </Tooltip>
                </IconButton>
              )}
            </Box>
          )}
          
          <Button 
            color="inherit" 
            onClick={salirSesionApp}
            className={classes.logoutButton}
            startIcon={<i className="material-icons">exit_to_app</i>}
          >
            Salir
          </Button>
          
          <Button 
            component={Link} 
            to="/perfil" 
            color="inherit"
            className={classes.userButton}
          >
            {sesionUsuario ? sesionUsuario.usuario.nombrecompleto : ''}
          </Button>
          
          <Avatar 
            src={sesionUsuario.usuario.imagenPerfil}
            className={classes.avatarSize}
            sx={{ ml: 1 }}
          />
        </div>
        
        <div className={classes.seccionMobile}>
          <IconButton 
            color="inherit" 
            onClick={abrirMenuDerechaAction}
            className={classes.iconButton}
          >
            <i className="material-icons">more_vert</i>
          </IconButton>
        </div>
      </Toolbar>
    </React.Fragment>
  );
};
export default withRouter(BarSesion);
//nuevo
